module.exports = __webpack_public_path__ + "img/pdf-icon.54364853.png";